import * as HOSTS from './host'
export const root = window
export const location = root.location
export const href = location.href

/**
 * [getEnvName description]
 * 获取对应的环境域名
 * @return {[String]}    [对应的环境]
 */
export function getEnvName() {
  const _hostName = location.origin
  let envName = ''
  // 一般生产环境的域名
  const prdReg = /^(http(s)?:\/\/)?.*\.(cn)?suning\.(cn|com)/
  // 一般pre环境的域名
  const preReg = /^(http(s)?:\/\/)?((.*)pre(.*)\.(cn)?suning\.(cn|com))/
  // 一般sit环境的域名
  const sitReg = /^(http(s)?:\/\/)?((.*)sit(.*)\.(cn)?suning\.(cn|com))/
  // 新港pre
  const preXGReg = /^(http(s)?:\/\/)?(.*)(prexg|xgpre)(.*)\.(cn)?suning\.(cn|com)/

  if (preXGReg.test(_hostName)) {
    envName = 'XGPRE'
  } else if (preReg.test(_hostName)) {
    envName = 'PRE'
  } else if (sitReg.test(_hostName)) {
    envName = 'SIT'
  } else if (
    prdReg.test(_hostName) &&
    _hostName.indexOf('dev.cnsuning.com') === -1 &&
    _hostName.indexOf('test.cnsuning.com') === -1
  ) {
    envName = 'PRD'
  } else {
    // process.env.NODE_ENV === 'development'
    envName = 'DEV'
  }
  return envName
}
/**
 * [getEnvUrl description]
 * 获取域名环境，这个方法先不删，暂时留着
 * @return {[Object]} [description]
 */
export function getEnvUrl() {
  return URL_CONST
}

/**
 * 获取hostName各发布环境下的域名或地址
 * 并自动补全格式 protocal+'//'+域名或链接
 * [getHost 自定义环境域名变量]
 * @param  {[type]} hostName [自定义的域名格式]
 * @return {[type]}          [description]
 */
export function getHost(hostName) {
  let h = hostName[getEnvName()]
  if (!/^https?/.test(h)) {
    h = location.protocol + (h.indexOf('//') === 0 ? h : '//' + h)
  }
  return h
}
/**
 * [protocol description]
 * 动态协议转换
 * @param  {[String]} url [需要转化的地址]
 * @return {[String]}     [转换后的链接]
 */
export function protocol(url, http) {
  // encodeURIComponent 方式需要先转下
  const ptcol = href
  let _url = ''

  if (url.indexOf('http:') === 0) {
    _url = http ? url : url.replace('http:', '')
  } else if (url.indexOf('https:') === 0) {
    _url = http ? url : url.replace('https:', '')
  } else {
    _url = ptcol.split(':')[0] + ':'
    if (url.indexOf('//') !== 0) {
      _url += '//' + url
    } else {
      _url += url
    }
  }
  return _url
}

/**
 * [getQueryString description]
 * 获取地址 QueryString
 * @param  {[type]} name [对应的 key ]
 * @return {[type]}      [description]
 */
export function getQueryString(name, url) {
  var key = {}
  var loc = url ? decodeURIComponent(url) : href
  if (loc.indexOf('?') <= -1) {
    return ''
  }
  // 清除hash路由对querystring的影响
  var qArr = loc
    .split('?')[1]
    .replace(/#\/.*/, '')
    .split('&')
  qArr.forEach(function (item, idx) {
    var _v_ = item.split('=')
    key[_v_[0]] = _v_[1]
  })
  if (name) {
    return key[name]
  } else {
    return key
  }
  // var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  // var r = root.location.search.substr(1).match(reg);
  // console.log(r)
  // if(r!=null)return  decodeURIComponent(r[2]); return null;
}
/**
 * [serialize description]
 * 在 stream post请求中将用作对象值编译成 URL编码的 字符串。
 * @param  {[type]} data [纯数据对象]
 * @return {[type]}      [description]
 */
export function serialize(data) {
  var serializeArray = []
  for (var keys in data) {
    serializeArray.push({
      name: keys,
      value: data[keys]
    })
  }
  var result = []
  serializeArray.forEach(function (item) {
    result.push(
      encodeURIComponent(item.name) + '=' + encodeURIComponent(item.value)
    )
  })
  return result.join('&')
}

/**
 * @description 判断当前环境是否为开发环境
 * @returns {Boolean}
 */
export function isDev() {
  return (
    (typeof process !== 'undefined' &&
      process.env.NODE_ENV === 'development') ||
    getEnvName().toLowerCase() === 'dev'
  )
}

/**
 * 'null', 'undefined', '', null, undefined
 * @param {*} arg
 */
export const isNullOrEmpty = arg =>
  (typeof arg === 'string' &&
    (arg.toLowerCase() == 'null' || arg.toLowerCase() == 'undefined')) ||
  (!arg && arg !== 0 && typeof arg != 'boolean' ? true : false)

export const forceHTTPS = link => link.replace(/https?/g, 'https')

export const forcePRDHTTPS = link =>
  getEnvName().toLowerCase() === 'prd' ? forceHTTPS(link) : link

export const LoginOutUrl =
  HOSTS.PASSPORT_HOST[getEnvName()] +
  '/login?service=' +
  encodeURIComponent(
    HOSTS.AUTH_HOST[getEnvName()] +
    '/auth?targetUrl=' +
    encodeURIComponent(location.href)
  ) +
  '&loginTheme=b2c'

//退出登录跳转地址
export const logOutUrl = `${HOSTS.PASSPORT_HOST[getEnvName()]}/logout?service=${HOSTS.AUTH_HOST[getEnvName()]}/union/home.htm`

